export type WebAppVersionInfo = {
  buildId: string;
  builtAt: string;
};

const getCurrentBuildId = (): string => {
  return typeof __APP_BUILD_ID__ !== 'undefined' && __APP_BUILD_ID__ ? __APP_BUILD_ID__ : 'dev';
};

const getCurrentBuiltAt = (): string => {
  return typeof __APP_BUILT_AT__ !== 'undefined' ? __APP_BUILT_AT__ : '';
};

const fetchDeployedVersion = async (): Promise<WebAppVersionInfo | null> => {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) return null;
    const data = await response.json();
    if (!data?.buildId) return null;
    return { buildId: data.buildId, builtAt: data.builtAt || '' };
  } catch (error) {
    console.warn('Web app version check failed (non-blocking):', error);
    return null;
  }
};

export const webAppVersionService = {
  getCurrentBuildId,
  getCurrentBuiltAt,
  fetchDeployedVersion,

  async checkForUpdate(): Promise<WebAppVersionInfo | null> {
    const deployed = await fetchDeployedVersion();
    if (!deployed) return null;
    if (deployed.buildId === getCurrentBuildId()) return null;
    return deployed;
  },

  forceReload(buildId?: string) {
    const cacheBuster = buildId ? `?v=${encodeURIComponent(buildId)}` : '';
    window.location.href = `${window.location.pathname}${cacheBuster}`;
  },
};
